import { z } from 'zod';

export const careerSchema = z.object({
    firstName: z.string().min(1, "errors.firstNameRequired"),
    lastName: z.string().min(1, "errors.lastNameRequired"),
    linkedinAccount: z.string().url("errors.invalidUrl").regex(/linkedin\.com/, "errors.linkedinUrlRequired").min(1, "errors.linkedinRequired"),
    whyCiqler: z.string().min(10, "errors.whyCiqlerMinLength"),
});
